import { createContext, useContext } from 'react';
import type { QueryKey } from 'react-query';
import { ViewType } from 'api/views/types';

export interface ViewContextProps {
  viewType: ViewType;
  viewSourceId?: number;
  queryKey: QueryKey;
}

const ViewContext = createContext<ViewContextProps | null>(null);

export const ViewContextProvider = ViewContext.Provider;

export const useViewContext = () => {
  const context = useContext(ViewContext);

  if (context === null) {
    throw new Error('useViewContext must be used within a ViewContextProvider');
  }

  return context;
};
